import { render, staticRenderFns } from "./queueIndex.vue?vue&type=template&id=53b8cc6f&scoped=true"
import script from "./queueIndex.vue?vue&type=script&lang=js"
export * from "./queueIndex.vue?vue&type=script&lang=js"
import style0 from "./queueIndex.vue?vue&type=style&index=0&id=53b8cc6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b8cc6f",
  null
  
)

export default component.exports